// En que esta Amix ahora (D52): lo pone el panel del asistente y lo leen el boton flotante y la cabecera. Las emociones
// de cierre (feliz, confundido...) vuelven solas al reposo pasado su tiempo.
import { useSyncExternalStore } from 'react';

import { DURACION, type EstadoAmix } from './cara';

let actual: EstadoAmix = 'reposo';
let vuelta: ReturnType<typeof setTimeout> | null = null;
const oyentes = new Set<() => void>();

export function ponerAmix(e: EstadoAmix) {
  if (vuelta) clearTimeout(vuelta);
  vuelta = null;
  const dura = DURACION[e];
  if (dura) vuelta = setTimeout(() => ponerAmix('reposo'), dura);
  if (e === actual) return;
  actual = e;
  oyentes.forEach((f) => f());
}
export const estadoAmix = () => actual;

export const useEstadoAmix = () =>
  useSyncExternalStore(
    (f) => (oyentes.add(f), () => oyentes.delete(f)),
    () => actual,
  );
